export default __webpack_public_path__ + "static/media/spratt11.25e757fc.jpg";